import { LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAILURE, SET_FIN_YEAR, SET_TOKEN_USER, SET_COMPANY, SET_CUSTOMER, SET_USER, SET_SUPER_USER } from '../types';

const initialState = {
  loading: false,
  token: null,
  finyear: null,
  user: null,
  superUser: null,
  customer: null,
  error: null,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_REQUEST:
      return {
        ...state,
        user: null,
        loading: true,
        error: null,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        ...action.payload,
        loading: false,
        error: null,
      };
    case LOGIN_FAILURE:
      return {
        ...state,
        loading: false,
        token: null,
        finyear: null,
        user: null,
        error: action.error,
      };
    case SET_TOKEN_USER:
      let tempUser = {};
      if (action.payload.token) {
        if (action.payload.user?.Role === "Super Admin" && !action.payload.user?.Created_User) {
          tempUser = { superUser: action.paylod.user, finyear: null, company: null };
        } else {
          if (action.payload.customer) {
            tempUser = { user: action.paylod.user, customer: action.payload.customer };
          } else {
            tempUser = { user: action.paylod.user };
          }
        }
      } else {
        tempUser = { user: null, superUser: null, customer: null };
      }  
      return {
        ...state,
        ...tempUser,
        token: action.payload.token,
      }
    case SET_FIN_YEAR:
      return {
        ...state,
        finyear: action.payload
      }
    case SET_COMPANY:
      return {
        ...state,
        company: action.payload
      }
    case SET_CUSTOMER:
      return {
        ...state,
        customer: action.payload
      }
    case SET_SUPER_USER:
      return {
        ...state,
        superUser: action.payload
      }
    case SET_USER:
      return {
        ...state,
        user: action.payload
      }
    default:
      return state;
  }
};

export default authReducer;
